/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://pwztjagllreinjk7g6g6e5i4hq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-46tl377gwfh43ixj6hmo7g6joy",
    "aws_cognito_identity_pool_id": "eu-central-1:ac042b50-d006-45ae-b0a3-9c69db14a8eb",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_jExvuiMcT",
    "aws_user_pools_web_client_id": "6ucvjqf6qfcjh665v4gjgssjkf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "digitalshielda87096904e4f48be8ea72b9060e565b1135952-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
